import ProtectionService from "../../../../services/protection.service";

export const submitSurveyApi = ({ operatorTCN, rating, feedback }) => {
  const payload = {
    OperatorTCN: operatorTCN,
    ServiceRating: rating,
    ServiceFeedback: feedback,
  };

  return ProtectionService.submitFraudSurveyFeedback(payload);
};
